(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-ldp"]) return;
  try {
    
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-super-serum-page"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header-super-serum-page');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > 43) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > 43) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      var headerHeightSticky = $('.page-recommend-routine #shopify-section-header,.page-skin-result #shopify-section-header').height();
      $('.page-recommend-routine .success-mess,.page-skin-result .success-mess').css('top', headerHeightSticky);
      //this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      var headerHeight = $('.page-recommend-routine .announcement-wrap,.page-skin-result .announcement-wrap').height() + $('.page-recommend-routine #shopify-section-header,.page-skin-result #shopify-section-header').height();
      if($('.page-recommend-routine .success-mess .form-message--success,.page-skin-result .success-mess .form-message--success')) {
        $('.page-recommend-routine .success-mess,.page-skin-result .success-mess').css('top', headerHeight);
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      return true;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-synternals"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header-synternals');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > 43) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > 43) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      var headerHeightSticky = $('.page-recommend-routine #shopify-section-header,.page-skin-result #shopify-section-header').height();
      $('.page-recommend-routine .success-mess,.page-skin-result .success-mess').css('top', headerHeightSticky);
      //this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      var headerHeight = $('.page-recommend-routine .announcement-wrap,.page-skin-result .announcement-wrap').height() + $('.page-recommend-routine #shopify-section-header,.page-skin-result #shopify-section-header').height();
      if($('.page-recommend-routine .success-mess .form-message--success,.page-skin-result .success-mess .form-message--success')) {
        $('.page-recommend-routine .success-mess,.page-skin-result .success-mess').css('top', headerHeight);
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      return true;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > 43) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > 43) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      var headerHeightSticky = $('.page-recommend-routine #shopify-section-header,.page-skin-result #shopify-section-header').height();
      $('.page-recommend-routine .success-mess,.page-skin-result .success-mess').css('top', headerHeightSticky);
      //this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      var headerHeight = $('.page-recommend-routine .announcement-wrap,.page-skin-result .announcement-wrap').height() + $('.page-recommend-routine #shopify-section-header,.page-skin-result #shopify-section-header').height();
      if($('.page-recommend-routine .success-mess .form-message--success,.page-skin-result .success-mess .form-message--success')) {
        $('.page-recommend-routine .success-mess,.page-skin-result .success-mess').css('top', headerHeight);
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      return true;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300))
  }
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              if(typeof jQuery == 'function' && typeof jQuery.fn.slick !== 'undefined') {
                let item = $(this).find('.grid__item').first();
                let product_grid = $(this).find('.product-grid').slick({
                  dots: true,
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  arrows: false,
                  centerMode: false,
                  infinite: false,
                  waitForAnimate: false,
                  touchThreshold: 15,
                  swipeToSlide: true,
                  responsive: [
                    {
                      breakpoint: 1025,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: false
                      }
                    },
                    {
                      breakpoint: 769,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: false
                      }
                    },
                    {
                      breakpoint: 426,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        variableWidth: true
                      }
                    }
                  ]
                });

                product_grid.on('swipe', function(event, slick, direction){
                  let item_width = slick.slideWidth ?? slick.$slides[0].offsetWidth;
                  let current_left = slick.currentLeft;
                  let current_slide = slick.currentSlide;
                  let current_item_position = current_slide * item_width;
                  let max_dot = slick.$dots.find('li').length;
                  if(
                    ((current_item_position + item_width) + current_left) < 0
                  ) {
                    let goto = current_slide + Math.abs(((current_left + current_item_position ) / item_width));

                    if(goto > max_dot) goto = max_dot - 1;
                    $(this).slick('slickGoTo', goto);
                  }
                  // left
                });
              }
              setTimeout(function(){
                if ($('.card-wrapper').length > 0) {
                  $('.card-wrapper').removeClass('card-wrapper--skeleton');
                }
                if ($('.article-card').length > 0) {
                  $('.article-card').removeClass('article-card--skeleton');
                }
              }, 2000);
            }
          })
          .catch(e => {
            console.error(e);
          });
    }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["syn-collection-list-homepage"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
	var index = 1;

	var html1 = $(".animation-notify .animation-hide").eq(0).html();
	var dataText1 = [html1];

	function typeWriter1(text, i, fnCallback) {
		if (i < (text.length)) {
			document.querySelector(".animation-show").innerHTML = text.substring(0, i + 1);
			setTimeout(function () {
				typeWriter1(text, i + 1, fnCallback)
			}, 70);
		}
		else if (typeof fnCallback == 'function') {
			setTimeout(fnCallback, 1000);
		}
	}

	function StartTextAnimation1(i) {
		if (typeof dataText1[i] == 'undefined') {
			setTimeout(function () {
				StartTextAnimation1(0);
			}, 5678910);
		}else if (i < dataText1[i].length) {
			typeWriter1(dataText1[i], 0, function () {
				StartTextAnimation1(i + 1);
			});
		}
	}
	StartTextAnimation1(0);

	function displayHello() {
		$(".animation-notify .animation-hide").eq(index).prevAll().removeClass("animation-show");
		$(".animation-notify .animation-hide").eq(index).addClass("animation-show").ready(function() {
			var html = $(".animation-show").html();
			var dataText = [html];

			function typeWriter(text, i, fnCallback) {
				if (i < (text.length)) {
					document.querySelector(".animation-show").innerHTML = text.substring(0, i + 1);
					setTimeout(function () {
						typeWriter(text, i + 1, fnCallback)
					}, 70);
				}
				else if (typeof fnCallback == 'function') {
					setTimeout(fnCallback, 1000);
				}
			}

			function StartTextAnimation(i) {
				if (typeof dataText[i] == 'undefined') {
					setTimeout(function () {
						StartTextAnimation(0);
					}, 5678910);
				}else if (i < dataText[i].length) {
					typeWriter(dataText[i], 0, function () {
						StartTextAnimation(i + 1);
					});
				}
			}
			StartTextAnimation(0);
		})
		if(index < $(".animation-notify .animation-hide").length - 1) {
			index = ++index;
			setTimeout(displayHello, 2000);
		}
	}
	setTimeout(displayHello, 3000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["syn-notify-cms"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
    var index = 1;

    var html1 = $(".animation-notify .animation-hide").eq(0).html();
    var dataText1 = [html1];

    function typeWriter1(text, i, fnCallback) {
        if (i < (text.length)) {
            document.querySelector(".animation-show").innerHTML = text.substring(0, i + 1);
            setTimeout(function () {
                typeWriter1(text, i + 1, fnCallback)
            }, 70);
        }
        else if (typeof fnCallback == 'function') {
            setTimeout(fnCallback, 700);
        }
    }

    function StartTextAnimation1(i) {
        if (typeof dataText1[i] == 'undefined') {
            setTimeout(function () {
                StartTextAnimation1(0);
            }, 5678910);
        }else if (i < dataText1[i].length) {
            typeWriter1(dataText1[i], 0, function () {
                StartTextAnimation1(i + 1);
            });
        }
    }
    StartTextAnimation1(0);

    console.log($(".animation-notify .animation-hide").eq(0).html());
    function displayHello() {   
        $(".animation-notify .animation-hide").eq(index).prevAll().removeClass("animation-show");
        $(".animation-notify .animation-hide").eq(index).addClass("animation-show").ready(function() {
            var html = $(".animation-show").html();
            var dataText = [html];

            function typeWriter(text, i, fnCallback) {
                if (i < (text.length)) {
                    document.querySelector(".animation-show").innerHTML = text.substring(0, i + 1);
                    setTimeout(function () {
                        typeWriter(text, i + 1, fnCallback)
                    }, 70);
                }
                else if (typeof fnCallback == 'function') {
                    setTimeout(fnCallback, 700);
                }
            }

            function StartTextAnimation(i) {
                if (typeof dataText[i] == 'undefined') {
                    setTimeout(function () {
                        StartTextAnimation(0);
                    }, 5678910);
                }else if (i < dataText[i].length) {
                    typeWriter(dataText[i], 0, function () {
                        StartTextAnimation(i + 1);
                    });
                }
            }
            StartTextAnimation(0);
        })
        if(index < $(".animation-notify .animation-hide").length - 1) {
            index = ++index;
            setTimeout(displayHello, 2000);
        }
    }
    setTimeout(displayHello, 2000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["syn-product-giftcard"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yotpo-faq"]) return;
  try {
    
    const questionContainers = document.querySelectorAll('.question-container');
  const answers = document.querySelectorAll('.answer');
  let activeAnswer = answers[0];

  // Adds the visible class to the first answer and rotate class to the first toggle button
  questionContainers[0].querySelector('.toggle-btn p').classList.add('rotate');
  activeAnswer.classList.add('visible');

  questionContainers.forEach((container, index) => {
    container.addEventListener('click', () => {
      const answer = answers[index];
      const toggleBtn = container.querySelector('.toggle-btn p');

      if (activeAnswer !== null && activeAnswer !== answer) {
        const activeToggleBtn = activeAnswer.previousElementSibling.querySelector('.toggle-btn p');
        activeToggleBtn.classList.remove('rotate');
        activeAnswer.classList.remove('visible');
      }

      toggleBtn.classList.toggle('rotate');

      if (answer.classList.contains('visible')) {
        answer.classList.remove('visible');
        activeAnswer = null;
      } else {
        answers.forEach((a) => {
          a.classList.remove('visible');
        });
        answer.classList.add('visible');
        activeAnswer = answer;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
